import { Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import styles from "./styles.module.scss";
import { useState } from "react";

interface UploadCSVModalProps {
  open: boolean;
  onCancel: () => void;
}

const UploadCSVModal: React.FC<UploadCSVModalProps> = ({ open, onCancel }) => {
  const [activeTab, setActiveTab] = useState("PO");
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      className={styles.uploadModal}
      centered
      closable
    >
      <div className={styles.modalContainer}>
        <h2 className={styles.title}>Upload</h2>
        <div className={styles.tabHeader}>
          <button
            className={activeTab === "PO" ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab("PO")}
          >
            PO
          </button>
          <button
            className={activeTab === "SO" ? styles.activeTab : styles.tab}
            onClick={() => setActiveTab("SO")}
          >
            SO
          </button>
        </div>

        <div className={styles.uploadBox}>
          <UploadOutlined className={styles.uploadIcon} />
          <p>
            Drag & drop files or{" "}
            <input type="file" accept=".csv" className={styles.browse} />
          </p>
          <p className={styles.supportText}>Supported format: CSV</p>
        </div>

        <div className={styles.bottomActions}>
          <p className={styles.sampleText}>
            Download a sample CSV file{" "}
            <span className={styles.download}>Download</span>
          </p>

          <div className={styles.actions}>
            <button onClick={onCancel} className={styles.cancelBtn}>
              Cancel
            </button>
            <button disabled className={styles.addBtn}>
              Add Data Entry
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UploadCSVModal;
